export default __webpack_public_path__ + "static/media/disabled_e-visa_ribon.609fabce.svg";